module.exports = __webpack_public_path__ + "static/media/sneha_desu_banner_mobile.4a3b858c.webp";